
export function getLotsWithTenantText(lots, tenantName) {
    let lotsWithTenantText = [];
    lots?.forEach(lot => {
        let l = { ...lot };
        if (!l.ownedByTenant) {
            l.name = lot.name + ' (Non ' + tenantName + ' Lot)';
        }
        lotsWithTenantText.push(l);
    });
    return lotsWithTenantText;
}